import Experience from "../Experience";

export default class Drawers {
  constructor () {
    this.experience = new Experience();

    const drawers = this.experience.params.drawers;

    for (const drawer of drawers) {
      const close = drawer.querySelector(".close");

      close.addEventListener("click", (event) => {
        event.preventDefault();

        const hotspot = document.querySelector(".hotspot[data-state='active']");

        if (hotspot) hotspot.dataset.state = "visible";

        this.close();
      });
    }
  }
  
  open (hotspot) {
    this.close();

    const section = document.querySelector("#" + hotspot.dataset.section);

    if (section) section.dataset.state = "open";
  }

  close() {
    const active = document.querySelector(".drawer[data-state=open]");

    if (active) active.dataset.state = "closed";

    this.experience.world.labels.hide();
    this.experience.world.hotspots.setInactive();
    this.experience.world.overlays.hide();
  }
}